export const CREATIVE_SCENES_PURPOSE_ID = 'creative-scenes';
export function createDefaultCollectionPurposes() {
    return separateCollectionPurposes([
        ['clean-mockups', 'Clean Mockups', ['STATIC', 'MOTION']],
        ['app-icons', 'App Icons', ['STATIC', 'MOTION']],
        ['ui-frames', 'UI Frames', ['STATIC', 'MOTION']],
        ['motion-constructor', 'Motion Constructor', ['MOTION']],
        ['finish-motion', 'Finish Motion', ['MOTION']],
        [CREATIVE_SCENES_PURPOSE_ID, 'Creative Scenes', ['STATIC', 'MOTION']]
    ].map(([id, name, contentTypes], order) => ({ id, name, contentTypes, order, background: '', fontColor: '#ffffff' })));
}
export function normalizeCollectionPurposeId(value) {
    return typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,126}$/.test(value) ? value : CREATIVE_SCENES_PURPOSE_ID;
}
export function collectionPurposeContentType(templateType) {
    return templateType.toUpperCase().startsWith('MOTION') ? 'MOTION' : 'STATIC';
}
/** Legacy URLs/assignments are resolved within their own catalog, never across catalogs. */
export function scopeCollectionPurposeId(value, templateType) {
    const id = normalizeCollectionPurposeId(value);
    return /^(static|motion)-/.test(id) ? id : `${collectionPurposeContentType(templateType).toLowerCase()}-${id}`;
}
export function isCreativeScenesPurpose(id) {
    return id === CREATIVE_SCENES_PURPOSE_ID || id === 'static-creative-scenes' || id === 'motion-creative-scenes';
}
export function collectionPurposeSupportsType(purpose, templateType) {
    return purpose.contentTypes.length === 1 && purpose.contentTypes[0] === collectionPurposeContentType(templateType);
}
export function normalizeCollectionPurpose(value) {
    if (!value || typeof value !== 'object')
        return null;
    const raw = value;
    if (typeof raw.id !== 'string' || !/^[a-z0-9][a-z0-9-]{0,126}$/.test(raw.id))
        return null;
    const name = typeof raw.name === 'string' ? raw.name.trim() : '';
    const contentTypes = ['STATIC', 'MOTION'].filter(type => Array.isArray(raw.contentTypes) && raw.contentTypes.includes(type));
    if (!name || name.length > 120 || contentTypes.length !== 1)
        return null;
    const id = scopeCollectionPurposeId(raw.id, contentTypes[0]);
    if (!id.startsWith(`${contentTypes[0].toLowerCase()}-`))
        return null;
    return { id, name, contentTypes,
        order: Number.isFinite(Number(raw.order)) ? Math.max(0, Math.floor(Number(raw.order))) : 0,
        background: typeof raw.background === 'string' ? raw.background : '',
        fontColor: typeof raw.fontColor === 'string' && /^#[0-9a-f]{6}$/i.test(raw.fontColor) ? raw.fontColor : '#ffffff',
        autoFontColor: typeof raw.autoFontColor === 'string' && /^#[0-9a-f]{6}$/i.test(raw.autoFontColor) ? raw.autoFontColor : undefined,
        autoBlurBackground: typeof raw.autoBlurBackground === 'string' ? raw.autoBlurBackground : undefined,
        published: raw.published !== false && raw.published !== 'false',
        listed: raw.listed !== false && raw.listed !== 'false' };
}
/** One-time legacy expansion is also used on reads during a rolling API deployment. */
export function separateCollectionPurposes(values) {
    const result = new Map();
    for (const value of values) {
        if (!value || typeof value !== 'object')
            throw new Error('Invalid collection purpose');
        const raw = value;
        const scopes = ['STATIC', 'MOTION'].filter(t => Array.isArray(raw.contentTypes) && raw.contentTypes.includes(t));
        if (!scopes.length)
            throw new Error('Invalid purpose scope');
        for (const scope of scopes) {
            const item = normalizeCollectionPurpose({ ...raw, contentTypes: [scope] });
            if (!item || result.has(item.id))
                throw new Error('Invalid or duplicate collection purpose');
            result.set(item.id, item);
        }
    }
    return [...result.values()];
}
